import { createI18n } from 'vue-i18n'
import pt from './locales/pt'
import en from './locales/en'
import es from './locales/es'
import de from './locales/de'
import fr from './locales/fr'
import it from './locales/it'
import zh from './locales/zh'
import ja from './locales/ja'
import ko from './locales/ko'
import ru from './locales/ru'
import nl from './locales/nl'

const LOCALE_KEY = 'obra_locale'

function getStoredLocale(): string {
  return localStorage.getItem(LOCALE_KEY) || 'pt'
}

const i18n = createI18n({
  legacy: false,
  locale: getStoredLocale(),
  fallbackLocale: 'pt',
  messages: { pt, en, es, de, fr, it, zh, ja, ko, ru, nl },
})

export function setLocale(locale: string) {
  const loc = i18n.global.locale as { value: string }
  loc.value = locale
  localStorage.setItem(LOCALE_KEY, locale)
  document.documentElement.setAttribute('lang', locale)
}

export function getLocale(): string {
  return (i18n.global.locale as { value: string }).value
}

export default i18n
